import { JobActiveStatus, JobFormDto } from 'core/models/job';
import { ExportTargetLink } from 'core/models/export';
import { request } from './ApiService';
import { OutputType } from 'core/models/filename';

const ENDPOINTS = {
  GET_QUERIES: '/api/v1/queriesHierarchic',
  STORES_REST: '/api/v1/stores',
  QUERIES_REST: '/api/v1/queries/',
  JOBS_REST: '/api/v1/jobs/',
  JOBS_REST_V2: '/api/v2/jobs/',
  JOB_ACTIVE_STATUS: '/api/v1/jobs/activity/',
  LOG_ENTRIES: '/api/v1/export/schedule/',
  JOB_EXECUTE: '/api/v1/export/:id/',
  REPORT_DOWNLOAD: '/api/v1/export/:id/file/',
  CHECK_EXPORT_TARGET: '/api/v3/exportTarget/check',
};

const getAll = () =>
  request(ENDPOINTS.JOBS_REST, undefined, { timeout: 15000 });

const getQueries = () => request(ENDPOINTS.GET_QUERIES);

const getStores = () => request(ENDPOINTS.STORES_REST);

const getQuery = (queryId: number) => request(ENDPOINTS.QUERIES_REST + queryId);

const getJob = (jobId: number) => request(ENDPOINTS.JOBS_REST_V2 + jobId);

const postNewJob = (job: JobFormDto) => {
  const parsedJob = {
    ...job,
    activeFrom: new Date(job.activeFrom).toISOString(),
    activeTo: new Date(job.activeTo).toISOString(),
    queryId: parseInt(job.queryId + ''),
  };
  return request(ENDPOINTS.JOBS_REST_V2, parsedJob, { method: 'POST' });
};

const updateJob = (job: JobFormDto) => {
  const parsedJob = {
    ...job,
    activeFrom: new Date(job.activeFrom).toISOString(),
    activeTo: new Date(job.activeTo).toISOString(),
    queryId: parseInt(job.queryId + ''),
  };
  return request(ENDPOINTS.JOBS_REST_V2 + job.id, parsedJob, { method: 'PUT' });
};

const deleteJob = (jobId: number) =>
  request(ENDPOINTS.JOBS_REST + jobId, null, { method: 'DELETE' });

const setJobActivity = (jobId: number, status: JobActiveStatus) =>
  request(ENDPOINTS.JOB_ACTIVE_STATUS + jobId, status, { method: 'PATCH' });

const getLogEntries = (jobId: number) =>
  request(ENDPOINTS.LOG_ENTRIES + jobId, null);

const runExport = (jobId: number) => {
  const path = ENDPOINTS.JOB_EXECUTE.replace(':id', jobId + '');
  return request(path, null, { method: 'POST' });
};

const getExportState = (location: string) => request(location);

const downloadReport = (logEntryId: number, outputType: OutputType) => {
  const params = new URLSearchParams({ outputType: outputType });
  const path =
    ENDPOINTS.REPORT_DOWNLOAD.replace(':id', logEntryId + '') +
    '?' +
    params.toString();
  return request(path, null, { method: 'GET' });
};

// Unified check endpoint
const checkExportTargetAccess = (url: string, storesIds: string[]) => {
  const body: ExportTargetLink = { url, storesIds };
  return request(ENDPOINTS.CHECK_EXPORT_TARGET, body, { method: 'POST' });
};

export const jobService = {
  getAll,
  getJob,
  getQueries,
  getStores,
  getQuery,
  postNewJob,
  updateJob,
  deleteJob,
  setJobActivity,
  getLogEntries,
  runExport,
  getExportState,
  downloadReport,
  checkExportTargetAccess,
};
